import { render, staticRenderFns } from "./VisaTippaniVerificationModal.vue?vue&type=template&id=357b4df4&"
import script from "./VisaTippaniVerificationModal.vue?vue&type=script&lang=js&"
export * from "./VisaTippaniVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports